import React from 'react'
import { Dots } from 'react-activity';
import './dots.css'
import 'react-activity/dist/react-activity.css';
import { connect } from 'react-redux'
import { setPercentage, setCancelToken } from '../../store/actions/percentage';

class DotsInd extends React.Component {

    componentWillUnmount() {
        setPercentage(0)
        if (this.props.cancelToken != null) this.props.cancelToken.cancel()
        setCancelToken(null)
    }
    render() {
        return (
            <div className="container-activity-dots">
                {this.props.percentage != 0
                    ?
                    <>
                        <p>{this.props.percentage} %</p>
                        <div style={{ width: this.props.percentage + "%", height: "10px", background: "#8dc640", alignSelf: "flex-start" }}></div>
                    </>
                    :
                    <Dots />
                }
            </div>
        )
    }

}
export default connect((store) => ({ percentage: store.percentage.percentage, cancelToken: store.percentage.cancelToken }), {})(DotsInd)
